import type {IWHISession} from '@nib/types-session-api';
import {FetchPriceFulfilledPayload} from './pricing/types';
import {FetchFeaturesFulfilledPayload} from './featureToggles/types';
import {FetchPpcConfigFulfilledPayload} from './ppcConfig/types';

export interface Action<TPayload = object> {
  type: string;
  payload: TPayload;
}

export type ResponseType = 'AxiosError' | 'Session' | 'Price' | 'Features' | 'PpcConfig';
export type HttpMethod = 'GET' | 'PUT' | 'POST';
export interface AxiosError {
  message?: string;
  request: any;
  response: any;
  isAxiosError: boolean;
  method: HttpMethod;
}

// Able to type guard against the response object
export interface AxiosResponse<T> {
  type: ResponseType;
  data: T;
}

// The return error type could be anything
export interface FailedRequestPayload {
  error?: AxiosError;
}

type AxiosResponseSuccess = AxiosResponse<IWHISession> | AxiosResponse<FetchPriceFulfilledPayload> | AxiosResponse<FetchFeaturesFulfilledPayload> | AxiosResponse<FetchPpcConfigFulfilledPayload>;

// If clearly defined as an axios error or the axios flag is on the axios error object - return type as AxiosError
export const isAxiosError = (axiosResponse: AxiosResponseSuccess | AxiosResponse<AxiosError>): axiosResponse is AxiosResponse<AxiosError> => {
  const responseType: ResponseType = axiosResponse.type;
  return responseType === 'AxiosError' && (axiosResponse as AxiosResponse<AxiosError>).data.isAxiosError !== undefined;
};
